import * as React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import reloadwhite from "../img/reload-white.png";
import styled from "styled-components";

const styles = (theme: any) => {
  return {
    button: {
      backgroundColor: "#E4002B",
      fontWeight: 300,
      letterSpacing: "1px",
      transition: "all 0.5s ease",
      color: "#fff",
      width: "100%"
    }
  };
};

interface IThemedButtonProps {
  children?: any;
  classes?: any;
  onButtonClick?: () => any;
  disabled?: any;
  styles?: any;
  component?: any;
  loading?: any;
}
const ThemedButton: React.SFC<IThemedButtonProps> = (
  props: IThemedButtonProps
) => {
  const isDisabled = props.disabled ? true : false;
  return (
    <Outer>
      <Button
        variant="contained"
        className={`${props.classes.button} button`}
        style={{ ...props.styles }}
        onClick={props.onButtonClick}
        disabled={isDisabled}
        component={props.component}
      >
        {props.loading ? <Loader src={reloadwhite} /> : props.children}
      </Button>
    </Outer>
  );
};

const Outer = styled.div`
  width: 80px;
  margin: 0 auto;

  .button {
    font-weight: 500;
    &:hover {
      background-color: #e4002b;
    }
  }
`;

const Loader = styled.img`
  animation: spin 1s infinite linear;

  @keyframes spin {
    from {
      transform: scale(1) rotate(0deg);
    }
    to {
      transform: scale(1) rotate(360deg);
    }
  }
`;

export default withStyles(styles)(ThemedButton);



// WEBPACK FOOTER //
// ./src/shared/Button.tsx